import React, { ChangeEvent } from "react";
import { Month } from "../../../domain/fundamental/Month";

// **** 注意 ****
// <input type="month"/>を利用しているのでIE11では動かない。
// 管理機能でのみ使うのでこれでよしとしている。ユーザー向け画面では決して使わないこと。

export function AdminMonthPicker(props: AdminMonthPicker) {
    const { currentMonth, whenDateChanged } = props;

    const handleChanged = (e: ChangeEvent<HTMLDataElement>) => {
        const value = e.target.value;
        whenDateChanged(value ? Month.fromString(value) : null);
    };

    return (
        <div className={"admin_month_picker"}>
            <input type={"month"} value={currentMonth?.format()} onChange={handleChanged}/>
        </div>
    );
}

export type AdminMonthPicker = {
    currentMonth: Month | null,
    whenDateChanged: (input: Month | null) => void,
};
